import { useTranslation } from "../../core/translation.core";
import { Order } from "../../types/order";
import { OrderInfo } from "../order/orderInfo.comp";
import { ProductList } from "../order/orderProductList.comp";
import { ShipDetails } from "../order/orderShipDetails.comp";
import { TotalBreakdown } from "../order/orderTotalBreakdown.comp";

export default function CombineOrderDetail({ order, onCombine }: { order: Order; onCombine: (orderId: string) => void }) {
  const { t, msg } = useTranslation();

  return (
    <div className="mx-auto text-neutral-gray space-y-12 leading-6">
      <div className="bg-white text-darks px-6 py-8 space-y-6 rounded-2xl">
        <div className="flex gap-4">
          <h3 className="text-primary text-xl font-semibold uppercase md:text-2xl">
            {t(msg.order.idL)}
            {order.orderNumber}
          </h3>
          <button
            type="button"
            className="px-3 text-white font-medium rounded bg-primary-light transition-colors text-base disabled:bg-gray-200"
            onClick={() => onCombine(order.id)}
          >
            {t(msg.order.combineOrder)}
          </button>
        </div>
        <hr />
        <OrderInfo order={order} />
        <hr />
        <p>{order?.activePaymentSession?.isPaymentOnDelivery ? t(msg.order.cashOnDeliveryMsg) : null}</p>

        <ShipDetails order={order} />
        <p>{order.pickupAddr && t(msg.order.storePickupMsg)}</p>
        <hr />
        <ProductList products={order.products} orderId={order.id} />
        <hr />
        <TotalBreakdown order={order} />
      </div>
    </div>
  );
}
